import $ from 'jquery';

import { $Elements, Classes, Elements, Events } from '../global/constants';
import { ajax } from '../global/helpers';

$Elements.document.on(Events.page.enter, () => {

	// ---------- Handle Form ----------

	function handleForm(form, params) {

		const formContent = form.find('.form-content');
		const formDone = form.find('.form-done');
		const formSuccess = formDone.find('.success');
		const formError = formDone.find('.error');
		const formButton = form.find('button[type=submit]');

		form.on('submit', e => e.preventDefault());

		form.parsley().on('form:submit', async function() {

			Elements.LoadingBar.classList.add(Classes.loading);
			formButton.attr('disabled', true);

			const formData = new FormData(form[0]);
			formData.append('action', params.action);

			try {

				const response = await ajax({
					url: params.url,
					type: 'POST',
					dataType: 'json',
					data: formData,
					processData: false,
					contentType: false,
				});

				formSuccess.removeClass(Classes.hidden);
			}
			catch(e) {
				formError.removeClass(Classes.hidden);
			}

			Elements.LoadingBar.classList.remove(Classes.loading);
			formButton.attr('disabled', false);
			formContent.addClass(Classes.hidden);
			formDone.removeClass(Classes.hidden);

			return false;
		});
	}

	// ---------- Contact Form ----------

	if(typeof contact_form_params !== 'undefined') {

		$('form.contact-form').each(function() {
			handleForm($(this), contact_form_params);
		});
	}

	// ---------- Contact Form Options ----------

	const $reasonSelect = $('#reason-select');

	if($reasonSelect.length) {

		const $contactContainer = $('.contact-options-container');
		const $methodWrapper = $('.contact-method-wrapper');
		const $methodSelect = $('#contact-method-select');
		const $phoneWrapper = $('.phone-callback-wrapper');
		const $daySelect = $('#callback-day-select');
		const $periodSelect = $('#callback-period-select');
		const $hoursText = $('.callback-hours-text');
		const $otherSubjectGroup = $('.other-subject-group');
		const $otherSubject = $('#other-subject');

		function populatePhoneFields($option) {
			const days = JSON.parse($option.attr('data-days') || '[]');
			const hours = JSON.parse($option.attr('data-hours') || '[]');
			const hoursText = $option.attr('data-hours-text') || '';

			$daySelect.empty();
			days.forEach(day => {
				$daySelect.append(`<option value="${day.value}">${day.label}</option>`);
			});

			$periodSelect.empty();
			hours.forEach(hour => {
				$periodSelect.append(`<option value="${hour.value}">${hour.label}</option>`);
			});

			$hoursText.html(hoursText);
		}

		$reasonSelect.on('change', function() {
			const $selected = $(this).find('option:selected');
			const hasEmail = $selected.attr('data-has-email') === '1';
			const hasPhone = $selected.attr('data-has-phone') === '1';
			const hasOther = $selected.attr('data-has-other') === '1';

			// Reset
			$methodSelect.prop('selectedIndex', 0);
			$phoneWrapper.addClass(Classes.hidden);

			// Other subject field
			if(hasOther) {
				const otherLabel = $selected.attr('data-other-request') || 'Veuillez préciser l\'objet de votre demande';
				$otherSubjectGroup.find('label').text(otherLabel);
				$otherSubjectGroup.removeClass(Classes.hidden);
				$otherSubject.attr('required', true);
			} else {
				$otherSubjectGroup.addClass(Classes.hidden);
				$otherSubject.removeAttr('required').val('');
			}

			if(hasEmail && hasPhone) {
				$contactContainer.removeClass(Classes.hidden);
				$methodWrapper.removeClass(Classes.hidden);
			}
			else if(hasPhone) {
				$contactContainer.removeClass(Classes.hidden);
				$methodWrapper.addClass(Classes.hidden);
				$methodSelect.val('phone');
				$phoneWrapper.removeClass(Classes.hidden);
				populatePhoneFields($selected);
			}
			else if(hasEmail) {
				$contactContainer.addClass(Classes.hidden);
				$methodSelect.val('email');
			}
			else {
				$contactContainer.addClass(Classes.hidden);
				$methodSelect.val('');
			}
		});

		$methodSelect.on('change', function() {
			const $selected = $reasonSelect.find('option:selected');

			if($(this).val() === 'phone') {
				$phoneWrapper.removeClass(Classes.hidden);
				populatePhoneFields($selected);
			}
			else {
				$phoneWrapper.addClass(Classes.hidden);
			}
		});
	}

});
